import Model, { attr, belongsTo, type AsyncBelongsTo } from '@ember-data/model';
import type LocationModel from 'garaje/models/location';

class AverageMonthlyVisitorCountModel extends Model {
  @belongsTo('location', { async: true, inverse: null }) declare location: AsyncBelongsTo<LocationModel>;
  @attr('number') declare count: number;
  @attr() declare locationId: string;
}

export default AverageMonthlyVisitorCountModel;

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'average-monthly-visitor-count': AverageMonthlyVisitorCountModel;
  }
}
